// import { getLoggedInUserInfo } from 'utils'
import actions from './actions'

const initialState = {
  avatar: '',
  authorized: true,
  userInfo: {},
  userDetailedInfo: {},
  isLoading: false,
  userProfileImageId: null,
  userProfileImageUrl: null,
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.USER_SET_STATE:
      return {
        ...state,
        ...action.payload,
      }
    case actions.USER_DETAILS:
      return {
        ...state,
        userDetailedInfo: action.payload,
      }
    case actions.USER_PROFILE_IMAGE:
      return {
        ...state,
        userProfileImageId: action.payload.id,
        userProfileImageUrl: action.payload.url,
      }
    case actions.USER_TOGGLE_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }
    case actions.USER_LOGOUT:
      return {
        ...initialState,
      }

    default:
      return state
  }
}
